class HulkBuilder {
	constructor() {
		this.state = {
			optionSet: null,
            maxHolesA: 3,
            maxHolesB: 3,
            currentNavStep: 1,
            currentImage: {
                width: 2,
                length: 8,
                sideA: 0,
                sideB: 0,
                bumpers: null
            }
		};
	}

	init() {
		window.addEventListener("load", () => {
			const polling = setInterval(() => {
				const optionSet = document.querySelector("div[id^='hulkapps_custom'] .hulkapps_option_set");

				if (optionSet) {
					clearInterval(polling);

					this.state.optionSet = optionSet;

					setTimeout(() => this.main(), 100);
				}
			}, 100);

            setTimeout(() => clearInterval(polling), 20000);
		});
	}

	main() {
		// this.removeAppCSS(); // DEV ONLY

		this.groupCustomElements();
		this.initSectionSwitcher();
        this.handleNextAndPrev();
        this.handleProductDescriptionPopover();
		this.addNumberInputControls();
        this.addGreenSpeedSlider();
        this.handleImageChange();
        this.createHoleToggle();
        // this.handleCupsAndFlags();
        this.handleSizeUpdate();
        this.handleBumpers();
        this.updateBumperOptions();
        this.handleLogoPreview();
	}

	removeAppCSS() {
		// DEV ONLY
		const parent = this.state.optionSet.closest("div[id^='hulkapps_custom']");

		const style = parent?.querySelector("style");
		if (style) style.remove();
	}

	groupCustomElements() {
		const groups = [
			{ className: "customSize", parentId: "sizes-section" },
			{ className: "customFeatures", parentId: "features-section" },
			{ className: "customLogo", parentId: "logo-section" }
		];

		groups.forEach(group => {
			const items = document.querySelectorAll("." + group.className);

			const parent = document.createElement("div");
			parent.id = group.parentId;
			parent.classList.add("options-section");

			if (group.className === "customSize") {
                const subSectionOne = document.createElement("div");
				subSectionOne.classList.add("size-subsection-1");

                const subSectionOneTitle = document.createElement("div");
				subSectionOneTitle.textContent = "Size of the Mat";
				subSectionOneTitle.className = "size-subsection-title";
				subSectionOne.appendChild(subSectionOneTitle);

				const subSectionTwo = document.createElement("div");
				subSectionTwo.classList.add("size-subsection-2");

				items.forEach((el, index) => {
					if (index < 1) {
						subSectionOne.appendChild(el);
					} else {
						subSectionTwo.appendChild(el);
					}
				});

				parent.appendChild(subSectionOne);
				parent.appendChild(subSectionTwo);

                const legend = document.createElement("div");
                legend.className = "size-legend";
                legend.innerHTML = `
                    <div class="legend-title">Legend</div>
                    <div class="legend-item">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#000000" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M14 12.0001C14 13.1046 13.1046 14.0001 12 14.0001C10.8954 14.0001 10 13.1046 10 12.0001C10 10.8955 10.8954 10.0001 12 10.0001C13.1046 10.0001 14 10.8955 14 12.0001Z" />
                                <path d="M8 6.99997C8 6.99997 10.946 3.00001 12 3C13.0541 2.99999 16 7 16 7" />
                                <path d="M16 17C16 17 13.054 21 12 21C10.9459 21 8 17 8 17" />
                            </svg>
                        </span>
                        <span>Width</span>
                    </div>
                    <div class="legend-item">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" color="#000000" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M16.5001 3.26621C17.3445 3.25421 20.141 2.67328 20.7339 3.26621C21.3268 3.85913 20.7459 6.65559 20.7339 7.5" />
                                <path d="M3.26631 16.5C3.25431 17.3444 2.67338 20.1409 3.26631 20.7338C3.85923 21.3267 6.65569 20.7458 7.5001 20.7338" />
                                <path d="M3.89561 20.0577L20.1047 3.94238" />
                            </svg>
                        </span>
                        <span>Length</span>
                    </div>
                `;

                parent.appendChild(legend);
            } else if (group.className === "customFeatures") {
				const subSectionOne = document.createElement("div");
				subSectionOne.classList.add("features-subsection-1");

				const subSectionOneTitle = document.createElement("div");
				subSectionOneTitle.textContent = "Hole & Flag Location";
				subSectionOneTitle.className = "features-subsection-title";
				subSectionOne.appendChild(subSectionOneTitle);

				const subSectionTwo = document.createElement("div");
				subSectionTwo.classList.add("features-subsection-2");

				items.forEach((el, index) => {
					if (index < 3) {
						subSectionOne.appendChild(el);
					} else {
						subSectionTwo.appendChild(el);
					}
				});

				parent.appendChild(subSectionOne);
				parent.appendChild(subSectionTwo);
			} else if (group.className === "customLogo") {
				const subSectionOne = document.createElement("div");
				subSectionOne.classList.add("logo-subsection-1");

				const subSectionTwo = document.createElement("div");
				subSectionTwo.classList.add("logo-subsection-2");

                const logoTitle = document.createElement("div");
                logoTitle.textContent = "Mat Surface and Flag Pins Customization";
                logoTitle.className = "logo-subsection-title";
                subSectionOne.appendChild(logoTitle);

				items.forEach((el, index) => {
					subSectionOne.appendChild(el);
				});

                subSectionTwo.innerHTML = `
                    <div class="logo-subsection-title">Flag Pin Preview</div>
                    <div class="flag-logo-preview">
                        <img alt="Flag pin preview" src="https://cdn.shopify.com/s/files/1/0514/6833/7337/files/Gemini_Generated_Image_4ueaow4ueaow4uea-cutout.png?v=1770556128" />
                        <img alt="" src="" />
                    </div>
                `;

				parent.appendChild(subSectionOne);
				parent.appendChild(subSectionTwo);
			}

			this.state.optionSet.appendChild(parent);
		});
	}

	initSectionSwitcher() {
        const navButtons = document.querySelectorAll(".nav-element");
        const sections = this.state.optionSet.querySelectorAll(".options-section");

        if (!navButtons.length || !sections.length) return;

        const showSection = (id) => {
            sections.forEach(sec => {
                sec.classList.remove("active");
                void sec.offsetWidth; // Force repaint
            });

            const target = document.getElementById(id);
            if (target) target.classList.add("active");
        }

        navButtons.forEach((btn, index) => {
            btn.addEventListener("click", () => {
                navButtons.forEach(b => b.classList.remove("active"));
                btn.classList.add("active");

                this.state.currentNavStep = index + 1;
                
                this.updateButtonStates(this.state.currentNavStep);

                const target = btn.getAttribute("data-target");
                if (target) showSection(target);
            });
        });

        navButtons[0].click(); 
    }

    updateButtonStates(step) {
        const prevBtn = document.getElementById("btn-prev");
        const nextBtn = document.getElementById("btn-next");
        const atcBtn = document.getElementById("btn-atc");

        if (step === 1) {
            prevBtn.classList.add("disabled");
        } else {
            prevBtn.classList.remove("disabled");
        }

        if (step === 3) {
            nextBtn.classList.remove("active");
            atcBtn.classList.add("active");
        } else {
            atcBtn.classList.remove("active");
            nextBtn.classList.add("active");
        }
    }

    handleNextAndPrev() {
        const navButtons = document.querySelectorAll(".nav-element");

        document.getElementById("btn-prev").addEventListener("click", () => {
            if (this.state.currentNavStep > 1) {
                navButtons[this.state.currentNavStep - 2].click();
            }
        });

        document.getElementById("btn-next").addEventListener("click", () => {

            if (this.state.currentNavStep < 3) {
                navButtons[this.state.currentNavStep].click();
            }
        });
    }

    handleProductDescriptionPopover() {
        const btn = document.getElementById("popover-btn");
        const popover = document.getElementById("popover-content");

        btn.addEventListener("click", (e) => {
            e.stopPropagation();
            popover.classList.toggle("hidden");
        });

        window.addEventListener("click", () => {
        if (!popover.classList.contains("hidden")) {
            popover.classList.add("hidden");
        }
        });

        popover.addEventListener("click", (e) => {
            e.stopPropagation();
        });
    }

	addNumberInputControls() {
		this.state.optionSet.querySelectorAll(".hulkapps_option.nf_render .hulkapps_option_value").forEach(el => {
            const side = el.previousElementSibling.getAttribute("aria-label").trim();

			const input = el.querySelector("input");
            input.readOnly = true;
            input.value = 0;

			const minusBtn = document.createElement("button");
			minusBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="11" height="11" color="currentColor" fill="none" stroke="#141B34" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 12L4 12" />
                </svg>
            `;
			minusBtn.className = "qty-btn minus";
			minusBtn.type = "button";

			const plusBtn = document.createElement("button");
			plusBtn.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="11" height="11" color="currentColor" fill="none" stroke="#141B34" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 4V20M20 12H4" />
                </svg>
            `;
			plusBtn.className = "qty-btn plus";
			plusBtn.type = "button";

			minusBtn.addEventListener("click", () => {
				let currentValue = parseInt(input.value) || 0;
				if (currentValue > 0) {
					input.value = currentValue - 1;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                    this.updateHoles(side, currentValue - 1);
				}
			});

			plusBtn.addEventListener("click", () => {
				let currentValue = parseInt(input.value) || 0;
                const maxHoles = side === "Side A" ? this.state.maxHolesA : this.state.maxHolesB;
				if (currentValue < maxHoles) {
                    input.value = currentValue + 1;
                    input.dispatchEvent(new Event("change", { bubbles: true }));
                    this.updateHoles(side, currentValue + 1);
                }
			});

			el.prepend(minusBtn);
			el.appendChild(plusBtn);
		});
	}

	addGreenSpeedSlider() {
        const container = this.state.optionSet.querySelector(".green-speed .hulkapps_option_value");
        const radioIds = ["1662920_0", "1662920_1", "1662920_2"];
        
        // Updated tooltip texts
        const tooltips = [
            "9-10 Stimp | Public Municipal",
            "10-11 Stimp | Private Course",
            "11-13 Stimp | Championship Course"
        ];

        const sliderWrapper = document.createElement("div");
        sliderWrapper.className = "custom-slider-wrapper";
        sliderWrapper.innerHTML = `
            <div class="slider-labels">
                <span class="s-label" data-index="0" data-tooltip="${tooltips[0]}">Slow</span>
                <span class="s-label" data-index="1" data-tooltip="${tooltips[1]}">Med</span>
                <span class="s-label" data-index="2" data-tooltip="${tooltips[2]}">Fast</span>
            </div>
            <div class="slider-wrapper">
                <div class="slider-container" id="sliderContainer">
                    <div class="slider-track-bg"></div>
                    <div class="slider-fill" id="sliderFill"></div>
                    <div class="slider-thumb" id="sliderThumb"></div>
                </div>
            </div>
        `;

        container.appendChild(sliderWrapper);

        const containerEl = sliderWrapper.querySelector("#sliderContainer");
        const thumb = sliderWrapper.querySelector("#sliderThumb");
        const fill = sliderWrapper.querySelector("#sliderFill");
        const labels = sliderWrapper.querySelectorAll(".s-label");

        let isDragging = false;

        // Helper to update the visual position and labels
        const setVisuals = (percent, snap = false) => {
            if (snap) {
                containerEl.classList.remove("is-dragging");
            } else {
                containerEl.classList.add("is-dragging");
            }

            // Slight offsets for aesthetics at the ends
            let visualPercent = percent;
            if (percent === 0) visualPercent = 2;
            else if (percent === 100) visualPercent = 98;
            
            thumb.style.left = `${visualPercent}%`;
            fill.style.width = `${visualPercent}%`;

            // Update active label based on nearest point
            const closestIndex = Math.round((percent / 100) * 2);
            labels.forEach((l, i) => l.classList.toggle("active", i === closestIndex));
        };

        const syncHulkApps = (index) => {
            const targetRadio = document.getElementById(radioIds[index]);
            if (targetRadio) {
                targetRadio.click();
                targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };

        const getPercentageFromEvent = (e) => {
            const rect = containerEl.getBoundingClientRect();
            const clientX = e.touches ? e.touches[0].clientX : e.clientX;
            let offset = (clientX - rect.left) / rect.width;
            return Math.max(0, Math.min(1, offset)) * 100;
        };

        // Click on labels
        labels.forEach(label => {
            label.addEventListener("click", () => {
                const index = parseInt(label.dataset.index);
                setVisuals(index * 50, true);
                syncHulkApps(index);
            });
        });

        // Drag Logic
        const onStart = (e) => {
            isDragging = true;
            const p = getPercentageFromEvent(e);
            setVisuals(p);
            if (e.type === 'mousedown') e.preventDefault(); 
        };

        const onMove = (e) => {
            if (!isDragging) return;
            const p = getPercentageFromEvent(e);
            setVisuals(p);
        };

        const onEnd = (e) => {
            if (!isDragging) return;
            isDragging = false;
            
            // Snap logic: Calculate based on current fill width/position
            const currentP = parseFloat(thumb.style.left);
            const closestIndex = Math.round((currentP / 100) * 2);
            
            setVisuals(closestIndex * 50, true);
            syncHulkApps(closestIndex);
        };

        containerEl.addEventListener("mousedown", onStart);
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onEnd);

        containerEl.addEventListener("touchstart", onStart, { passive: false });
        window.addEventListener("touchmove", onMove, { passive: false });
        window.addEventListener("touchend", onEnd);

        // Initial State (Med)
        setVisuals(50, true);
    }

    handleImageChange() {
        const $slider = $(".slick-track").closest(".slick-slider");
        if (!$slider.length || !this.state.optionSet) return;

        const goToImage = () => {
            const width = this.state.currentImage.width;
            const length = this.state.currentImage.length;
            
            let sideA = parseFloat(this.state.currentImage.sideA) || 0;
            let sideB = parseFloat(this.state.currentImage.sideB) || 0;
            
            const bumpers = this.state.currentImage.bumpers;

            let value = "";

            if (width && length) {
                value = width + "x" + 14;

                let sideABVal;
                if (sideB > sideA) {
                    sideABVal = `${sideB}A${sideA}B`;
                } else {
                    sideABVal = `${sideA}A${sideB}B`;
                }
                
                value += "_" + sideABVal;

                if (bumpers) {
                    value += "_" + bumpers;
                }

                console.log("Searching for alt text containing:", value);
            }

            let targetIndex = -1;
            $slider.find(".slick-slide").each(function () {
                const img = this.querySelector("img");
                if (!img) return;

                if (img.alt.trim().includes(value)) {
                    targetIndex = $(this).data("slick-index");
                    return false;
                }
            });

            if (targetIndex !== -1) {
                $slider.slick("slickGoTo", targetIndex);
            }
        };

        this.state.optionSet
            .querySelectorAll(".hulkapps_option.rb_render.customSize .radio_div")
            .forEach(radio => {
                if (radio.dataset.slickBound) return;
                radio.dataset.slickBound = "true";
                const isWidth = radio.closest(".hulkapps_option")?.classList.contains("width_ra");

                radio.addEventListener("click", () => {
                    const val = (radio.dataset.value || radio.textContent.trim()).replace(/\D+/g, "");
                    if (isWidth) {
                        this.state.currentImage.width = parseInt(val);
                        this.state.currentImage.length = null;
                    } else {
                        this.state.currentImage.length = parseInt(val);
                    }

                    const nextBtn = document.getElementById("btn-next");
                    const navBtnsList = document.querySelectorAll(".nav-element:not(.active)");
                    if (this.state.currentImage.width && this.state.currentImage.length) {
                        nextBtn.classList.remove("disabled");
                        navBtnsList.forEach(el => el.classList.remove("disabled"));
                    } else {
                        nextBtn.classList.add("disabled");
                        navBtnsList.forEach(el => el.classList.add("disabled"));
                    }

                    goToImage();
                });
            });

        this.state.optionSet
            .querySelectorAll(".hulkapps_option.nf_render input[type='number']")
            .forEach(input => {
                if (input.dataset.slickBound) return;
                input.dataset.slickBound = "true";
                const isSideA = input.nextElementSibling.name.includes("Side A");

                input.addEventListener("change", (e) => {
                    const val = e.target.value; 
                    isSideA ? this.state.currentImage.sideA = val : this.state.currentImage.sideB = val;
                    goToImage();
                });
            });
        
        const bumperSelect = this.state.optionSet.querySelector(".hulkapps_option.dd_render select");
        if (bumperSelect) {
            bumperSelect.addEventListener("change", (e) => {    
                const rawValue = e.target.value.split('[')[0]; 

                const cleanValue = rawValue
                    .replace(/[^a-zA-Z0-9 ]/g, "")
                    .trim()
                    .replace(/^\d+/, "")
                    .replace(/\s+/g, "");

                this.state.currentImage.bumpers = cleanValue || "";
                goToImage();
            });
        }
    }

    createHoleToggle() {
        const container = this.state.optionSet.querySelector(".hole-cutter .hulkapps_check_option .hulkapps-custom-check");
        container.innerHTML = `
            <div id="main-wrapper">
                <div class="off">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="8" height="8" color="#000000"
                        fill="none" stroke="#000000" stroke-width="4" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10" />
                    </svg>
                </div>
                <div class="pin">
                    <div></div>
                </div>
                <div class="on">
                    <div></div>
                </div>
            </div>
        `;

        const tooltipEl = document.createElement("div");
        tooltipEl.className = "hole-cutter-tooltip";
        tooltipEl.innerHTML = `
            <span>I want to cut my own holes</span>
            <span>(comes with 3 cups/flags)</span>
        `;

        container.parentElement.appendChild(tooltipEl);

        container.previousElementSibling.addEventListener("change", e => {
            if (e.target.checked) {
                container.style.setProperty("border-color", "#92c83e", "important");
                container.style.setProperty("background", "rgba(156, 198, 93, .1)", "important");
                container.querySelector("#main-wrapper").style.transform = "translateX(-33px)";

                this.updateHoles("Side A", 0);
                this.updateHoles("Side B", 0);

                this.state.optionSet.querySelectorAll(".features-subsection-1 .nf_render").forEach(op => {
                    op.classList.add("disabled");
                    op.querySelector("input[type='number']").value = 0;
                    op.querySelector("input[type='hidden']").value = 0;
                });
            } else {
                container.style.setProperty("border-color", "rgba(0,0,0,.2)", "important");
                container.style.setProperty("background", "rgba(0, 0, 0, 0)", "important");
                container.querySelector("#main-wrapper").style.transform = "translateX(0)";

                this.state.optionSet.querySelectorAll(".features-subsection-1 .nf_render").forEach(op => op.classList.remove("disabled"));
            }
        });
    }

    // handleCupsAndFlags() {
    //     this.state.optionSet.querySelectorAll(".cups-flags input[type='radio']").forEach(radio => {
    //         radio.addEventListener("change", e => {
    //             const val = e.target.dataset.conditionalValue;

    //             if (val > 2) {
    //                 const d = parseInt(val / 2);
    //                 this.state.maxHolesA = val % 2 === 0 ? d : d + 1;
    //                 this.state.maxHolesB = d;

    //                 const inputA = this.state.optionSet.querySelector(".customFeatures > div[aria-label='Side A'] + div input");
    //                 const inputB = this.state.optionSet.querySelector(".customFeatures > div[aria-label='Side B'] + div input");
                    
    //                 if (val < parseInt(inputA.value) + parseInt(inputB.value)) {
    //                     inputA.value = val % 2 === 0 ? d : d + 1;
    //                     inputB.value = d;
    //                 }
    //             }
    //         });
    //     });
    // }

    handleSizeUpdate() {
        const sizePreview = document.querySelector(".size-preview");
        sizePreview.querySelector(".size-preview-element:first-child > span:nth-child(2)").textContent = this.state.currentImage.width;
        sizePreview.querySelector(".size-preview-element:nth-child(2) > span:nth-child(2)").textContent = this.state.currentImage.length;

        this.state.optionSet.querySelectorAll(`
            .hulkapps_option.rb_render.width_ra .radio_div,
            .hulkapps_option.rb_render.length_ra_2 .radio_div,
            .hulkapps_option.rb_render.length_ra_3 .radio_div,
            .hulkapps_option.rb_render.length_ra_4 .radio_div
        `).forEach(radio => {
            radio.addEventListener("click", e => {
                const val = e.target.dataset.displayVal;

                const parent = e.target.closest(".hulkapps_option.rb_render");
                if (parent.classList.contains("width_ra")) {
                    sizePreview.querySelector(".size-preview-element:first-child > span:nth-child(2)").textContent = val;
                    sizePreview.querySelector(".size-preview-element:nth-child(2) > span:nth-child(2)").textContent = "";
                } else {
                    sizePreview.querySelector(".size-preview-element:nth-child(2) > span:nth-child(2)").textContent = val;
                }

                this.updateBumperOptions();
            });
        });
    }

    updateHoles(side, quantity) {
        const preview = document.querySelector(".holes-preview");
        if (!preview) return;

        const sidePrefix = side === "Side A" ? "left" : "right";

        const sideHoles = preview.querySelectorAll(`.hole-${sidePrefix}`);
        sideHoles.forEach(hole => hole.classList.remove("active"));

        const holeMap = {
            1: ["one"],
            2: ["two-up", "two-down"],
            3: ["two-up", "two-down", "three"]
        };

        const activeSuffixes = holeMap[quantity] || [];
        activeSuffixes.forEach(suffix => {
            const selector = `.hole-${sidePrefix}-${suffix}`;
            preview.querySelector(selector)?.classList.add("active");
        });

        let total = 0;
        this.state.optionSet
            .querySelectorAll(".hulkapps_option.nf_render input[type='number']")
            .forEach(input => {
                total += parseFloat(input.value) || 0;
            });

        this.state.optionSet.querySelector(`.cups_cost label[aria-label^="${total}"]`)?.click();
    }

    handleBumpers() {
        const dropdown = this.state.optionSet.querySelector(".customFeatures > div[aria-label='Bumpers'] + div select");
        const preview = document.querySelector(".bumpers-preview");
        dropdown.addEventListener("change", e => {
            const val = e.target.value.trim().toLowerCase();

            const bumpers = preview.querySelectorAll(".bumper");
            bumpers.forEach(bum => bum.classList.remove("active"));

            if (val.includes("end bumpers")) {
                const bumper = preview.querySelector(".bumper-end");
                bumper.classList.add("active");
            } else if (val.includes("u bumpers")) {
                const bumper = preview.querySelector(".bumper-u");
                bumper.classList.add("active");
            } else if (val.includes("end + side bumpers")) {
                const bumper = preview.querySelector(".bumper-end-side");
                bumper.classList.add("active");
            }
        });
    }

    updateBumperOptions() {
        const { width, length } = this.state.currentImage;
        const selectElement = document.querySelector(".features-subsection-2 .dd_render select");
        if (!selectElement) return;

        // 1. Store the original options if you haven't yet
        if (!this.allBumperOptions) {
            this.allBumperOptions = Array.from(selectElement.options);
        }

        // 2. Clear current options
        selectElement.innerHTML = "";

        // 3. Filter and append
        this.allBumperOptions.forEach(option => {
            const val = option.value;
            let shouldShow = false;

            if (val === "" || val === "End bumpers") {
                shouldShow = true;
            } else {
                const match = val.match(/^(\d+)/);
                const optionValueNum = match ? parseInt(match[1], 10) : null;

                if (val.includes('U bumpers')) {
                    shouldShow = (optionValueNum === parseInt(width));
                } else if (val.includes('End + side bumpers')) {
                    shouldShow = (optionValueNum === parseInt(length));
                }
            }

            if (shouldShow) {
                selectElement.appendChild(option.cloneNode(true));
            }
        });

        selectElement.value = ""; 
    }

    handleLogoPreview() {
        const fileInputs = this.state.optionSet.querySelectorAll(".customLogo input[type='file']");
        
        const logoPreviewImg = document.querySelector(".logo-preview img");
        const flagPreviewImg = document.querySelector(".flag-logo-preview img:nth-child(2)");

        fileInputs.forEach((input, index) => {
            input.addEventListener("change", () => {
                const file = input.files[0];
                if (!file || !file.type.startsWith("image/")) return;

                const reader = new FileReader();

                reader.onload = e => {
                    if (index === 0) {
                        if (logoPreviewImg) logoPreviewImg.src = e.target.result;
                    } else {
                        if (flagPreviewImg) {
                            flagPreviewImg.src = e.target.result;
                            flagPreviewImg.style.display = "block";
                        }
                    }
                };

                reader.readAsDataURL(file);
            });
        });

        this.state.optionSet.querySelectorAll(".mat_logo input[type='radio']").forEach(radio => {
            radio.addEventListener("change", e => {
                const logoPreview = document.querySelector(".logo-preview");
                if (e.target.value.startsWith("No")) {
                    logoPreview.style.display = "none";
                } else {
                    logoPreview.style.display = "block";
                }
            });
        });

        this.state.optionSet.querySelectorAll(".pin_logo input[type='radio']").forEach(radio => {
            radio.addEventListener("change", e => {
                const logoPreview = document.querySelector(".flag-logo-preview img:nth-child(2)");
                if (e.target.value.startsWith("No")) {
                    logoPreview.style.display = "none";
                } else if (flagPreviewImg.src.startsWith("data")) {
                    logoPreview.style.display = "block";
                }
            });
        });
    }
}

new HulkBuilder().init();